import { BaseModel } from "model/base.model";

export interface  PowerModule extends BaseModel {
    code?: string;
    name?: string;
};

export const defaultPowerModule: Readonly<PowerModule> = {};